// import { LanhuAPI } from "lanhu-core"
import setLanhuAPI from "@/common/js/setLanhuAPI.js"
// 是否使用打包使用 dev 环境
const isProdUseDev = false

function settings() {
    function isWeixin() {
        //判断是否是微信
        let ua = navigator.userAgent.toLowerCase()
        return ua.match(/MicroMessenger/i) == "micromessenger"
    }

    //是否是内置浏览器
    function isWebview() {
        let useragent = navigator.userAgent
        let rules = ["WebView", "(iPhone|iPod|iPad)(?!.*Safari/)", "Android.*(wv|.0.0.0)"]
        let regex = new RegExp(`(${rules.join("|")})`, "ig")

        if (isWeixin()) {
            return false
        } else {
            return Boolean(useragent.match(regex))
        }
    }
    console.log('test')
    let domain = "lanhuapp"
    // let domain = "lanhuhu"
    let baseURL = `https://${domain}.com`
    let webview = isWebview()
    let useCustomServer = false

    if (webview) {
        if (isProdUseDev) {
            baseURL = `https://dev.${domain}.com`
        }
        else {
            baseURL = `https://${domain}.com`
        }
    } else {
        let hostUrl = location.hostname
        let testPathArr = ["localhost", `dev.${domain}.com`, "127.0.0.1", "0.0.0.0"]

        if (hostUrl == `${domain}.com`) {
            baseURL = `https://${domain}.com`
            window.socketUrl = `https://ws.${domain}.com`
        } else if (hostUrl.includes('.develop')) {
            const result = location.hostname.match(/www-([\w-\d]+)\.develop\.lanhuapp\.com/) || [];
            const identity = result.length ? `www-${result[1]}` : 'www.develop';
            baseURL = `https://${identity}.develop.${domain}.com`
            window.socketUrl = `https://ws.${domain}.com`
        } else if (testPathArr.includes(hostUrl)) {
            baseURL = `https://develop.${domain}.com`
            window.socketUrl = `https://develop.${domain}.com`
        } else {
            baseURL = location.origin
            window.socketUrl = location.origin
            useCustomServer = true
        }
    }

    if (localStorage.baseURL && localStorage.baseURL != "undefined") {
        baseURL = localStorage.baseURL
    }
    // 切换接口数据
    // baseURL = `https://${domain}.com`;

    let settingsData = {
        isWebview: webview,
        useCustomServer,
        baseURL
    }

    window.isWebview = settingsData.isWebview
    window.useCustomServer = settingsData.useCustomServer
    window.baseURL = settingsData.baseURL
    // 添加域名，全局变量
    window.domain = domain

    //配置lanhuAPI
    window.setLanhuAPI = setLanhuAPI
    window.setLanhuAPI()
    // alert(location.hostname)
    console.log('settingsData: ', settingsData)
    return settingsData
}

// let settingsData = settings()

export default settings
